/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Leveling_Ladder_Role_NameInputs */



/**
* | output |
* | --- |
* | "@{name}" |
*
* @param {Leveling_Ladder_Role_NameInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_ladder_role_name = /** @type {((inputs: Leveling_Ladder_Role_NameInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Ladder_Role_NameInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`@${i?.name}`)
	return /** @type {LocalizedString} */ (`@${i?.name}`)
});